export default "/assets/images/app-update-img-01.webp?8aff8487ea81acb1a8717403d42d3a1d";